import { Axios, AxiosResponse } from 'axios'
import { RootState } from '@/store'
import { ResponseTaishakuTaishoExportLayout, TaishakuTaishoKmkType } from '@/repositories/keiei-joho/taishaku-taisho/data'
import { TaishakuTaishoKmkTypeType } from '@/repositories/keiei-joho/data'

type PostItem = {
  kmkType: TaishakuTaishoKmkTypeType;
  kin: number | null;
}
type PostParamItem = {
  startDate: string;
  endDate: string;
  kmkTypes: PostItem[];
}

export interface TaishakuTaishoExportRepository {
  checkCorporationInfoExists (): Promise<boolean>;
  getKmkTypes (): Promise<ResponseTaishakuTaishoExportLayout>;
  save (allKmkTypes: TaishakuTaishoKmkType[]): Promise<void>;
  recalculate (): Promise<ResponseTaishakuTaishoExportLayout>;
  export (): Promise<AxiosResponse>;
}

export class TaishakuTaishoExportRepositoryImpl implements TaishakuTaishoExportRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/taishaku-taisho/export`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  /**
   * 法人情報の存在チェック
   */
  async checkCorporationInfoExists (): Promise<boolean> {
    const { data } = await this.http.get(`${this.baseUrl}/check-corporation`)
    return data
  }

  /**
   * 貸借対照表科目タイプと法人情報のデータ取得
   */
  async getKmkTypes (): Promise<ResponseTaishakuTaishoExportLayout> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const { data } = await this.http.get(`${this.baseUrl}/${startDate}/${endDate}`)
    return data
  }

  /**
   * 登録
   */
  async save (allKmkTypes: TaishakuTaishoKmkType[]): Promise<void> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const items: PostItem[] = allKmkTypes.map(p => ({
      kmkType: p.kmkType,
      kin: p.kin
    }))
    const postParam: PostParamItem = {
      startDate: startDate,
      endDate: endDate,
      kmkTypes: items
    }
    await this.http.post(`${this.baseUrl}/save`, postParam)
  }

  /**
   * 再集計
   */
  async recalculate (): Promise<ResponseTaishakuTaishoExportLayout> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const { data } = await this.http.get(`${this.baseUrl}/recalculate/${startDate}/${endDate}`)
    return data
  }

  /**
   * 出力
   */
  async export (): Promise<AxiosResponse> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    return await this.http.post(`${this.baseUrl}/export/${startDate}/${endDate}`, {}, { responseType: 'blob' })
  }
}
